{
  "version": "1.2.6",
  "objects": {
    "7536295496405466067": {
      "type": "frame",
      "id": "7536295496405466067",
      "z": 11807,
      "textContent": "",
      "left": 2755.7422789211464,
      "top": 1216.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.3741424752783919,
      "scaleY": 0.7520623374613304,
      "fill": "#FBFBFB",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 5,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295496396862686": {
      "type": "frame",
      "id": "7536295496396862686",
      "z": 10570,
      "textContent": "",
      "left": 2775.7422789211464,
      "top": 1535.7475693125707,
      "width": 1110,
      "height": 625,
      "scaleX": 0.33810643924235584,
      "scaleY": 0.209375,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295496405466067",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0AXl",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 5,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7536295496408066032": {
      "type": "frame",
      "id": "7536295496408066032",
      "z": 10571,
      "textContent": "",
      "left": 2780.7422789211464,
      "top": 1540.7475693125707,
      "width": 1110,
      "height": 625,
      "scaleX": 0.3290974302333468,
      "scaleY": 0.1296,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295496396862686",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a11iu4LE",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295496403626166": {
      "type": "shape",
      "id": "7536295496403626166",
      "z": 10577,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#B6B6B6\">Paragraph text</span></p>",
      "left": 2780.7422789211464,
      "top": 1591.7475693125707,
      "width": 102,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7536295496408066032",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10m4",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295496402357478": {
      "type": "shape",
      "id": "7536295496402357478",
      "z": 10787,
      "shapeName": "text",
      "textContent": "<p>Product title</p>",
      "left": 2780.7422789211464,
      "top": 1540.7475693125707,
      "width": 84,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7536295496408066032",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a048T",
      "wrapText": null,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295496408999117": {
      "type": "frame",
      "id": "7536295496408999117",
      "z": 10572,
      "textContent": "",
      "left": 2780.7422789211464,
      "top": 1621.7475693125707,
      "width": 1110,
      "height": 625,
      "scaleX": 0.3290974302333468,
      "scaleY": 0.063775,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295496396862686",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a29tO",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295496400547716": {
      "type": "wireframe",
      "id": "7536295496400547716",
      "z": 10579,
      "top": 1622.2475693125707,
      "left": 3067.3441374176614,
      "width": 77.6962890625,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7536295496408999117",
      "layoutPosition": "a19TF",
      "wireframeName": "button",
      "fill": "#008E95",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Buy now",
        "iconLeft": null,
        "iconRight": null
      }
    },
    "7536295496407047033": {
      "type": "shape",
      "id": "7536295496407047033",
      "z": 10581,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#333333\">$11.00</span></p>",
      "left": 2780.7422789211464,
      "top": 1625.1772568125707,
      "width": 51.625,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7536295496408999117",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a020K",
      "maskType": "none",
      "locked": false
    },
    "7536295496410998707": {
      "type": "frame",
      "id": "7536295496410998707",
      "z": 10573,
      "textContent": "",
      "left": 2775.7422789211464,
      "top": 1236.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.33810643924235584,
      "scaleY": 0.47068733746133046,
      "fill": "#0CB4B4",
      "opacity": 0.1,
      "container": "7536295496405466067",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 2,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295496404896843": {
      "type": "frame",
      "id": "7536295496404896843",
      "z": 10574,
      "textContent": "",
      "left": 2785.7422789211464,
      "top": 1281.4273583992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.32008842122433784,
      "scaleY": 0.38291233746133047,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295496410998707",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a31bV",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295496410590343": {
      "type": "shape",
      "id": "7536295496410590343",
      "z": 10917,
      "shapeName": "icon",
      "textContent": "",
      "left": 2897.4716250657984,
      "top": 1347.3516817480206,
      "width": 100,
      "height": 80,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.3183945526971073,
      "scaleY": 1.3183945526971073,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#6ECDDB",
      "angle": 0,
      "container": "7536295496404896843",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a01eP",
      "maskType": "none",
      "iconName": "fas/shirt",
      "locked": false
    },
    "7536295496406307661": {
      "type": "frame",
      "id": "7536295496406307661",
      "z": 10575,
      "textContent": "",
      "left": 2785.7422789211464,
      "top": 1246.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.32008842122433784,
      "scaleY": 0.052575,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295496410998707",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1Bwh",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 5,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "center"
    },
    "7536295496406752036": {
      "type": "wireframe",
      "id": "7536295496406752036",
      "z": 10578,
      "top": 1252.0679833992392,
      "left": 3045.6820280426614,
      "width": 89.3583984375,
      "height": 22.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7536295496406307661",
      "layoutPosition": "a01aM",
      "wireframeName": "pill",
      "fill": "#03A9AF",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": {},
      "placeholder": { "value": "Best seller" },
      "showBackground": true,
      "showOutline": false
    }
  }
}
